import { fade } from '@material-ui/core/styles';
import palette from '../palette';

export default {
  root: {},
  paper: {
    border: `1px solid ${fade(palette.divider, 0.5)}`,
  },
};
